import React from "react";
import styled from "@emotion/styled";

const Table = styled.table(
  ({
    theme,
    border,
    noWrap,
    borderSpacing = 0,
    borderCollapse = "collapse",
    globalTableWidth,
    fitToScreenWidth,
    columnQuantity,
  }) => `
    border-spacing: ${borderSpacing};
    border-collapse: ${borderCollapse};
    display: table;
    font-size: 13px;
    width: ${globalTableWidth || "100%"};
    
    th {
      border: none;
    }
    td, th {
      ${border && `border-bottom: 1px solid ${theme.divider};`};
      height: 30px;
      padding: 2px 10px;
      text-align: left;
      white-space: ${noWrap ? "nowrap" : "normal"};
      text-overflow: ${noWrap ? "ellipsis" : "auto"};
      padding-bottom: 6px;
      ${
        fitToScreenWidth &&
        `
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: calc(100% / ${columnQuantity || 1});
        `
      };
    }

  ${fitToScreenWidth && `table-layout: fixed;`};
`
);

export default React.memo(
  React.forwardRef((props, ref) => {
    return (
      <Table
        border={props.border}
        id={props.tableId}
        noWrap={props.noWrap}
        borderSpacing={props.borderSpacing}
        borderCollapse={props.borderCollapse}
        ref={ref}
        globalTableWidth={props.globalTableWidth}
        columnQuantity={props.columnQuantity}
        fitToScreenWidth={props.fitToScreenWidth}
      >
        {props.children}
      </Table>
    );
  })
);
